/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stocktake_Notes_Placeholder_OptionalInputs */

const vi_stocktake_notes_placeholder_optional = /** @type {(inputs: Stocktake_Notes_Placeholder_OptionalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tùy chọn`)
};

/**

* @param {Stocktake_Notes_Placeholder_OptionalInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const stocktake_notes_placeholder_optional = /** @type {((inputs?: Stocktake_Notes_Placeholder_OptionalInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stocktake_Notes_Placeholder_OptionalInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_stocktake_notes_placeholder_optional(inputs)
});